import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_BLOG_DETAIL: string = typeCreatorV2(
  'BlogsShowDetailReducer',
  'SetBlogsDetail'
);
export const SET_LATEST_NEWS: string = typeCreatorV2(
  'BlogsShowDetailReducer',
  'SetLatestNews'
);
